import React, {useRef, useEffect, useState} from 'react';
import TopContents from '../../components/revenue/dashboard/TopContents';
import Adfit from "../../components/revenue/dashboard/Adfit";
import Adsense from "../../components/revenue/dashboard/Adsense";
import Dable from "../../components/revenue/dashboard/Dable";
import Tenping from "../../components/revenue/dashboard/Tenping";
import RevenueTips from "../../components/revenue/RevenueTips";
import EventManager from "../../../../tiara/src/EventManager";
import RevenueDialog from "../../components/revenue/RevenueDialog";
import {addPrefix} from "../../utils/UriUtil";
import {jsonResponseHandler} from "../../utils/FetchHelper";
import {setAdfitInfo, setAdsenseInfo} from "../../actions/revenue";
import {useDispatch} from "react-redux";

const RevenueApp = () => {
  const [dialogInfo, setDialogInfo] = useState();
  const adfitRef = useRef();
  const dispatch = useDispatch();

  const receiveMessage = (event) => {
    if (event.data && event.data.source === 'oauthConnect') {
      if (event.data.status === 'ok' && event.data.code === 200) {
        window.location.reload();
      } else {
        const info = {
          title: `${event.data.appService} 연동 권한 확인`,
          content: event.data.customMessage ? event.data.customMessage : event.data.message,
          confirm: ()=>setDialogInfo(null),
          cancel: false,
        };
        if (event.data.createResourceAccount) {
          info.confirm = ()=>{window.open(event.data.createResourceAccount);setDialogInfo(null)}
        }
        if (event.data.logoutUrl) {
          info.confirm = ()=>{location.href = event.data.logoutUrl;};
        }
        setDialogInfo(info);
      }
    }
  };
  const scrollToAdfit = () => {
    adfitRef.current.handleClickConnectButton();
    window.scrollTo({
      top: 470,
      left: 0,
      behavior: 'smooth',
    });
  };
  useEffect(() => {
    EventManager.add('message', receiveMessage);

    fetch(addPrefix("/manage/revenue/status/adfit.json"), {
      method: 'GET',
      credentials: 'include'
    })
      .then(jsonResponseHandler(dispatch))
      .then(r => r.json())
      .then(data => {
        dispatch(setAdfitInfo(data.data));
      })
      .catch(e => {
        console.log(e);
      });
    fetch(addPrefix("/manage/revenue/status/adsense.json"), {
      method: 'GET',
      credentials: 'include'
    })
      .then(jsonResponseHandler(dispatch))
      .then(r => r.json())
      .then(data => {
        dispatch(setAdsenseInfo(data.data));
      })
      .catch(e => {
        console.log(e);
      });
  }, []);
  return (
    <div className="inner_article">
      {dialogInfo &&
      <RevenueDialog
        title={dialogInfo.title}
        content={dialogInfo.content}
        close={()=>setDialogInfo(null)}
        confirm={dialogInfo.confirm}
        cancel={dialogInfo.cancel}
        confirmLabel={dialogInfo.confirmLabel}
        cancelLabel={dialogInfo.cancelLabel}
      />
      }
      <h2 id="kakaoBody" className="screen_out">블로그관리 본문</h2>
      <h3 className="screen_out">수익</h3>
      <h4 className="screen_out">수익센타 소개</h4>
      <TopContents onClickConnectAdfitButton={scrollToAdfit}/>
      <h4 className="tit_cont">광고 플랫폼</h4>
      <div className="list_box">
        <Adfit ref={adfitRef}/>
        <Adsense/>
        <Dable/>
        <Tenping/>
      </div>
      <RevenueTips selectable/>
    </div>
  )
};

export default RevenueApp;